import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';

const DashboardView = ({ ...props }) => {
    return <Container fluid>TODO</Container>;
};
export default DashboardView;
